import type { AboutInvestorRelationsContent } from '../types/AboutInvestorRelationsContent';

export function createAboutInvestorRelationsPlaceholder(): AboutInvestorRelationsContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
        Overview: {
            title: { kind: 'plainText', key: '', content: 'Overview' },
            mainText: { kind: 'richText', key: '', content: '', sanitizedContent: '' },
            mainImage: { kind: 'image', key: '', imageUrl: '' },
            stockQuoteLink: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
            MonthlyStatements: {
                title: { kind: 'plainText', key: '', content: 'Monthly Statements' },
                table: {
                    kind: 'partitionedTable',
                    key: '',
                    commonTableHeader: [],
                    tablePartitions: [],
                },
            },
            DividendPolicy: {
                title: { kind: 'plainText', key: '', content: 'Dividend History' },
                table: { kind: 'table', key: '', tableHeader: [], tableBody: [] },
            },
            AnalystCoverage: {
                title: { kind: 'plainText', key: '', content: 'Analyst Coverage' },
                table: { kind: 'table', key: '', tableHeader: [], tableBody: [] },
                referenceDate: { kind: 'plainText', key: '', content: 'As of 01/01/2025' },
            },
            ShareholderStructure: {
                title: { kind: 'plainText', key: '', content: 'Shareholder Structure' },
                image: { kind: 'image', key: '', imageUrl: '' },
                referenceDate: { kind: 'plainText', key: '', content: 'As of 01/01/2025' },
            },
            StakeholderCommunication: {
                title: { kind: 'plainText', key: '', content: 'Stakeholder Communication' },
                table: { kind: 'table', key: '', tableHeader: [], tableBody: [] },
                pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
            },
            MajorShareholders: {
                title: { kind: 'plainText', key: '', content: 'Major Shareholders' },
                table: { kind: 'table', key: '', tableHeader: [], tableBody: [] },
                referenceDate: { kind: 'plainText', key: '', content: 'As of 01/01/2025' },
            },
            TaxReportingForms: {
                title: { kind: 'plainText', key: '', content: 'Tax Reporting Forms' },
                icon: { kind: 'image', key: '', imageUrl: '' },
                form2025: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
                form2022: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
                form2018: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
            },
        },
        FinancialReports: {
            title: { kind: 'plainText', key: '', content: 'Financial Reports' },
        },
        InvestorConference: {
            title: { kind: 'plainText', key: '', content: 'Investor Conference' },
        },
        ShareholderMeetings: {
            title: { kind: 'plainText', key: '', content: 'Shareholder Meetings' },
        },
        Resources: {
            title: { kind: 'plainText', key: '', content: 'Resources' },
        },
    };
}
